import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Asset, Case, Contact } from 'src/app/shared/model/itsm';
import { ErrorService } from 'src/app/shared/services/error.service';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import {Router} from "@angular/router";
import { OktaAuthService } from 'src/app/app.service';
import { faGlasses } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-supportlog',
  templateUrl: './supportlog.component.html',
  styleUrls: ['./supportlog.component.scss']
})
export class SupportLogComponent implements OnInit {

  caseRef: string;
  case: Case;
  caseloading: boolean;
  vendor: string;
  vendorSearch: string;

  userObject: any;

  page: string;
  saved: boolean;
  reqTypeValue: string;

  // dropdown cache
  caseTypeCV: string[];
  caseCategoryCV: string[];
  casePriorityCV: string[];
  caseAssetCV: Asset[];
  caseStatusCV: string[];
  contacts: Contact[];
  entitlements: any[];

  vendors: any[];
  serviceNames: string[];
  filteredEntitlements: any[];
  filteredAssets: Asset[];

  showAssets: boolean;
  assetError: boolean;
  validCombinations: string[];
  loadingCache: boolean;
  serviceName: string;
  allowedCaseTypes: string[];

  constructor(private errorService: ErrorService, private itsmService: ItsmService, private route: ActivatedRoute, private router: Router, private auth: OktaAuthService) { }

  ngOnInit() {
    //Hard coded case types to not have to pull all types
    this.route.params.subscribe(params => this.caseRef = params['caseRef']);
    this.loadingCache = false;
    this.caseTypeCV = ["Change Request", "Incident", "Service Request"];

    // try {
    //   // Test up to 20 MB
    //   for (var i = 250; i <= 20000; i += 250) {
    //     localStorage.setItem('test', new Array((i * 1024) + 1).join('a'));
    //   }
    // } catch (e) {
    //   localStorage.removeItem('test');
    //   console.log(e)
    //   console.log('Local Storage Max Size is:', (i - 250)/1000, 'MB');            
    // }

    this.loadCache();

    if(this.caseRef){
      this.caseloading = true;
      this.itsmService.case(this.caseRef)
        .then(res => {
          this.case = res;
          this.caseloading = false;
        })
        .catch(err => {
          this.errorService.handlerError(err);
          this.caseloading = false;
        });
    }else{
      this.case = new Case();
      this.allowedCaseTypes = [];

      this.auth.getUserDetails().then(val => {
        val.groups.map(g => {
          if(g.includes('Create_')){
            this.allowedCaseTypes.push(g.substr(g.indexOf('Create_')+7));
          }
        });

        // filter case type by roles
        this.caseTypeCV = this.caseTypeCV.filter(t => 
          (t === 'Change Request' && this.allowedCaseTypes.includes("Change_Request")) ||
          (t === 'Service Request' && this.allowedCaseTypes.includes("Service_Request")) ||
          (t === 'Incident' && this.allowedCaseTypes.includes("Incident"))
        );

        this.userObject = val;
        if(this.contacts){
          let cs = this.contacts.filter(c => c.email === this.userObject.email);
          if(cs.length > 0){
            this.case.contactId = cs[0].id;
          }
        }
      });
    }

    this.page = 'create';
  }

  changePage(page: string){
    this.page = page;
  }

  /**
   * Submit case
   */
  submit(){
    if(this.submitValid()){
      this.assetError = false;
      this.saved = false;
      this.case.reqType = this.reqTypeValue;

      if(this.case.entitlementId != null) {
        let entitlement = this.entitlements.find(ent => ent.id == this.case.entitlementId);
        this.case.serviceType = entitlement["serviceType"];
        this.case.serviceName = entitlement["serviceName"];
      }

      this.page = 'submit';
      
      if(this.case.id){
        this.itsmService.caseUpdate(this.case)
          .then(res => {
            this.case = res;
            this.saved = true;
          })
          .catch(err => {
            this.errorService.handlerError(err);
          });
      }else{
        this.itsmService.caseCreate(this.case)
          .then(res => {
            this.case = res;
            this.saved = true;
            this.goToCase(this.case.id);
          })
          .catch(err => {
            this.errorService.handlerError(err);
          });
      }
    }
  }

  /**
   * Cache the CV values for the dropdowns
   */
  loadCache(){
    this.loadingCache = true;
    Promise.all([
      Promise.resolve(), // was this.itsmService.getCachedCV('Case','Type'),
      this.itsmService.getCachedCV('Case','Priority'),
      this.itsmService.getCachedAssets(),
      this.itsmService.getCachedCV('Case','Status'),
      this.itsmService.getCachedContacts(),
      this.itsmService.getCachedServices()
    ])
    .then(res => {
      this.casePriorityCV = res[1].filter(n => n == "1 - Business Critical" || 
                                               n == "2 - High" ||
                                               n == "3 - Medium" ||
                                               n == "4 - Low");
      this.caseAssetCV = res[2];
      this.caseStatusCV = res[3];
      this.contacts = res[4];
      this.entitlements = res[5];
      this.vendor = '';

      this.getTicketableEntitlements();
    //  this.getTicketableAssets();
      this.extractServiceNames();
      this.extractVendors();

      this.filteredAssets = this.caseAssetCV

      if(this.caseAssetCV && this.caseAssetCV.length > 0){
        this.reqTypeValue = "supOp";
      }else if(this.entitlements && this.entitlements.length > 0){
        this.reqTypeValue = "detResp"
      }
    })
    .then(() => {
      this.loadingCache = true;
    })
    .then(() => {
      this.loadingCache = false;
    })
    .catch(err => {
      this.errorService.handlerError(err);
    });
  }

  //Redirect to case created
  goToCase(caseId){
    this.router.navigate(['/support/view', caseId]);
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  extractServiceNames() {
    let serviceNames = [];
    serviceNames = this.entitlements.map(e => e.serviceName || e.name);
    serviceNames = serviceNames.filter(sn => sn !== "");
    serviceNames = serviceNames.filter(this.onlyUnique);
    serviceNames = serviceNames.sort((sn1, sn2) => (sn1.toLowerCase() > sn2.toLowerCase()) ? 1 : -1);
    this.serviceNames = serviceNames;
  }

  extractVendors() {
    let vendors = [];
    vendors = this.caseAssetCV.map(a => a.vendor);
    vendors = vendors.filter(v => v !== "");
    vendors = vendors.filter(this.onlyUnique);
    this.vendors = vendors;
  }

  getTicketableEntitlements() {
    this.entitlements = this.entitlements.filter(e => {
      // some UK contracts can't have tickets logged against them, and are flagged with "nonTicketable"
      var ticketable = (e.nonTicketable && e.nonTicketable === "true") ? false : true;
      var active = (e.active === "true");
      return active && ticketable;
    });
  }

  getTicketableAssets() {
    let assets = [];
    // get all contract ids a ticket can be logged against
    let contracts = this.entitlements;
    let contractIds = contracts.map(c => c.id);

    assets = this.caseAssetCV.filter(a => {
      let active = (a.active === "true");
      let hasContract = false;

      // we can skip the loop if the asset is already eliminated for being inactive
      if (active) {
        if (a.entitlements && a.entitlements.length > 0) {
          // check asset has at least one usable contract
          a.entitlements.forEach(e => {
            if (contractIds.indexOf(e.id) !== -1) {
              hasContract = true;
            }
          });
        }
      }

      return (active && hasContract);
    });

    this.caseAssetCV = assets;
  }

  changeAsset() {
    let serviceName = this.serviceName;
    let entitlementId = this.case.entitlementId;
    let assetId = (this.case.assetId) ? this.case.assetId : false;

    // auto-select the assets "first" entitlement, or one matching the selected serviceName (if set)
    let entitlements = this.getEntitlementsForAsset(assetId);
    if (entitlements.length > 0) {
      let entitlement;

      if (this.serviceName) {
        entitlement = this.findEntitlementForAssetAndService(assetId, this.serviceName);
      }

      // fall back to the "first" entitlement the asset has
      entitlement = entitlement || entitlements[0];
      this.case.entitlementId = entitlement.id;
      this.serviceName = entitlement.serviceName || entitlement.name;
    } else {
      // otherwise reset the entitlement and service selection
      this.case.entitlementId = undefined;
      this.serviceName = "default"
    }
  }

  changeService() {
    let serviceName = this.serviceName;

    if (!serviceName || (serviceName === "default")) {
      // clear all asset selections
      this.case.entitlementId = undefined;
      this.case.assetId = undefined;

    } else {
      let entitlementId = this.case.entitlementId;
      let assetId = (this.case.assetId) ? this.case.assetId : false;
      let entitlement;

      // check if any of the select asset's entitlements, are for this service
      if (assetId) {
        let assetEntitlements = this.getEntitlementsForAsset(assetId);
        if (assetEntitlements.length > 0) {
          entitlement = this.findEntitlementForAssetAndService(assetId, serviceName);
        }
      }

      if (entitlement) {
        // if we found an entitlement for the assetid + service
        this.case.entitlementId = entitlement.id;
      } else {
        // otherwise fall back to the "first" entitlement's "first" asset
        let entitlements = this.getEntitlementsForService(serviceName);
        if (entitlements.length > 0) {
          let entitlementId = entitlements[0].id;
          this.case.entitlementId = entitlementId;

          let assets = this.getAssetsForEntitlement(entitlementId);
          if (assets.length > 0) {
            let assetId = assets[0].id;
            this.case.assetId = assetId;
          } else {
            this.case.assetId = undefined;
          }
        } else {
          this.case.entitlementId = undefined;
          this.case.assetId = undefined;
        }
      }
    }
  }

  getEntitlementsForAsset(assetId) {
    let asset = this.caseAssetCV.find(a => a.id == assetId);

    if (asset) {
      asset.entitlements = asset.entitlements || [];
      let assetEntitlementIds = asset.entitlements.map(e => e.id);
      return this.entitlements.filter(a => assetEntitlementIds.indexOf(a.id) > -1);
    } else {
      return [];
    }
  }

  getEntitlementsForService(serviceName) {
    if (serviceName) {
      return this.entitlements.filter(e => (e.serviceName === serviceName) || e.name === serviceName);
    } else {
      return [];
    }
  }

  getAssetsForEntitlement(entitlementId) {
    if (entitlementId) {
      return this.caseAssetCV.filter(a => {
        if (a.entitlements && a.entitlements.length > 0) {
          let entitlementIds = a.entitlements.map(e => e.id);
          return entitlementIds.indexOf(entitlementId) > -1;
        }
      });
    } else {
      return [];
    }
  }

  findEntitlementForAssetAndService(assetId, serviceName) {
    let result = false;

    if (assetId && serviceName) {
      let entitlements = this.getEntitlementsForAsset(assetId);

      if (entitlements.length > 0) {
        result = entitlements.find(e => e.serviceName == serviceName);
        if (!result) {
          // fallback to name if serviceName didn't match
          result = entitlements.find(e => e.name == serviceName);
        }
      }
    }

    return result;
  }

  updateAssetFilter() {
    this.filteredAssets = this.caseAssetCV;

    if (this.vendor !== "") {
      this.filteredAssets = this.filteredAssets.filter(asset => asset.vendor === this.vendor);
    }

    // filter assets by search string
    if (this.vendorSearch && (this.vendorSearch !== "")) {
      var val = this.vendorSearch.toLowerCase();
      this.filteredAssets = this.filteredAssets.filter(a => {
        return (a.fullName.toLowerCase().indexOf(val) !== -1);
      });
    }
  }

  submitValid() :  boolean{
    if( 
        (
          this.case.type &&
          this.case.subject &&
          this.case.description &&
          this.case.contactId &&
          (this.case.assetId || this.case.entitlementId)
        )
        &&
        (
          (this.case.type === 'Change Request' && this.case.changeType)
            ||
          (this.case.type === 'Incident' && this.case.priority && this.case.priority !== '1 - Business Critical')
            ||
          (this.case.type === 'Service Request')
        )
      ){
        return true;
      }else{
        return false;
      }
  }


}
